export default __webpack_public_path__ + "static/media/sweets1.5dab7834.jpg";